module.exports = __webpack_public_path__ + "img/sljz.37e40782.svg";